import React from "react";

import S from "./strings";
import { TabProps } from "./helpers";
import { DeepLink } from "./enrollmentUpdatesController";
import ActualizarTab from "./actualizarTab";
import PorAplicarTab from "./porAplicarTab";
import FlotantesTab from "./flotantesTab";
import HistorialTab from "./historialTab";
import "./styles.css";

export const TABS = ["actualizar", "aplicar", "flotantes", "historial"] as const;
export type TabKey = typeof TABS[number];

interface Props {
	campusName: string;
	movil: boolean;
	tab: TabKey;
	onTab: (t: TabKey) => void;
	onGoTo: (t: TabKey) => void;
	counts: { pending: number; returned: number; floating: number };
	notice: { text: string; ok: boolean } | null;
	onCloseNotice: () => void;
	tabProps: TabProps;
	link: DeepLink;
}

const EnrollmentUpdatesView: React.FC<Props> = ({ campusName, movil, tab, onTab, counts, notice, onCloseNotice, tabProps, link }) => {
	const tabs: { key: TabKey; label: string; count?: number; oro?: boolean }[] = [
		{ key: "actualizar", label: S.tabs.actualizar },
		{ key: "aplicar", label: S.tabs.aplicar, count: counts.pending + counts.returned },
		{ key: "flotantes", label: S.tabs.flotantes, count: counts.floating, oro: true },
		{ key: "historial", label: S.tabs.historial },
	];
	return (
		<div className={"wau" + (movil ? " movil" : "")}>
			<div className="wau-cab"><div>{campusName ? <span className="wau-ceja">{campusName}</span> : ""}<h2>{S.title}</h2></div></div>
			<div className="wau-tabs" role="tablist">
				{tabs.map((t) => (
					<button key={t.key} type="button" role="tab" className="wau-tab" aria-selected={tab === t.key} onClick={() => onTab(t.key)}>
						{t.label}{t.count ? <small className={"wau-num" + (t.oro ? " oro" : "")}>{t.count}</small> : ""}
					</button>
				))}
			</div>
			{notice ? <div className={"wau-aviso " + (notice.ok ? "ok" : "mal")} role="status"><span>{notice.text}</span><button type="button" aria-label={S.close} onClick={onCloseNotice}>×</button></div> : ""}
			{tab === "actualizar" ? <ActualizarTab {...tabProps} link={link} /> : ""}
			{tab === "aplicar" ? <PorAplicarTab {...tabProps} initialId={link.updateId} /> : ""}
			{tab === "flotantes" ? <FlotantesTab {...tabProps} /> : ""}
			{tab === "historial" ? <HistorialTab {...tabProps} /> : ""}
		</div>
	);
};

export default EnrollmentUpdatesView;
